(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const anchorScrollBtn = document.querySelector('.js-benefits-anchor-scroll');

    if (anchorScrollBtn) {
      anchorScrollBtn.addEventListener('click', function (e) {
        e.preventDefault();

        const targetSelector = this.getAttribute('data-scroll-target');
        if (!targetSelector) return;

        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
          const elementRect = targetElement.getBoundingClientRect();
          const bodyRect = document.body.getBoundingClientRect();
          const offset = elementRect.top - bodyRect.top - 100;

          document.body.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-box-lp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-scroll-selector]');
    if (!link) return;
    var target = document.querySelector(link.dataset.scrollSelector);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var section = document.querySelector('.buyBoxLpSection[data-sale-price]');
  if (section) {
    window.buyBoxStickyPrice = section.dataset.salePrice;
    window.buyBoxCurrencySymbol = section.dataset.currencySymbol;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["confidence-corner"] && !Shopify.designMode) return;
  try {
    
  function initConfidenceCornerScroll() {
    window.scrollToBlocks = function (element) {
      const scrolldiv = document.querySelector(element);
      if (scrolldiv) {
        const elementRect = scrolldiv.getBoundingClientRect();
        const bodyRect = document.body.getBoundingClientRect();
        const offset = elementRect.top - bodyRect.top - 50;

        document.body.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
        window.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
      } else {
        window.location.href = `/${element}`;
      }
    };
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConfidenceCornerScroll);
  } else {
    initConfidenceCornerScroll();
  }

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    const sectionElement = document.querySelector(
      '.confidenceCorner[data-section-id="' + event.detail.sectionId + '"]'
    );
    if (sectionElement) {
      initConfidenceCornerScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["his-hers-bundle"] && !Shopify.designMode) return;
  try {
    
  function initHisHersBundleScroll() {
    const scrollButtons = document.querySelectorAll('.js-scroll-to');

    scrollButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        const targetSelector = this.getAttribute('data-scroll-target');
        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', initHisHersBundleScroll);

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    const sectionElement = document.querySelector('.hisHersBundle[data-section-id="' + event.detail.sectionId + '"]');
    if (sectionElement) {
      initHisHersBundleScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-banner"] && !Shopify.designMode) return;
  try {
    
  function initInfoBannerScroll() {
    const scrollButtons = document.querySelectorAll('.js-scroll-to');

    scrollButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        const targetSelector = this.getAttribute('data-scroll-target');
        const targetElement = document.querySelector(targetSelector);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      });
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', initInfoBannerScroll);

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    const sectionElement = document.querySelector('.infoBanner[data-section-id="' + event.detail.sectionId + '"]');
    if (sectionElement) {
      initInfoBannerScroll();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicles-offer"] && !Shopify.designMode) return;
  try {
    
  function initCountdownTimer() {
    const counterElement = document.querySelector('.js-offer-counter');
    const hoursElement = document.querySelector('.js-offer-hrs');
    const minutesElement = document.querySelector('.js-offer-mins');
    const secondsElement = document.querySelector('.js-offer-sec');

    if (!counterElement || !hoursElement || !minutesElement || !secondsElement) {
      return;
    }

    const updateCountdown = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const timeRemaining = midnight.getTime() - now.getTime();

      if (timeRemaining > 0) {
        const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        hoursElement.textContent = hours.toString().padStart(2, '0');
        minutesElement.textContent = minutes.toString().padStart(2, '0');
        secondsElement.textContent = seconds.toString().padStart(2, '0');
      } else {
        hoursElement.textContent = '24';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';
      }
    };

    updateCountdown();

    setInterval(updateCountdown, 1000);
  }

  document.addEventListener('DOMContentLoaded', initCountdownTimer);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.js-offer-counter')) {
      initCountdownTimer();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-nav"] && !Shopify.designMode) return;
  try {
    
  window.scrollToBlock = function (element) {
    var scrolldiv = document.querySelector(element);
    if (scrolldiv) {
      var elementRect = scrolldiv.getBoundingClientRect();
      var bodyRect = document.body.getBoundingClientRect();
      var offset = elementRect.top - bodyRect.top - 50;

      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }
  };

  } catch(e) { console.error(e); }
})();
})();
